import {Component, Input, OnChanges} from '@angular/core';
import {MatCell, MatColumnDef, MatHeaderCell, MatRow, MatTable, MatTableModule} from '@angular/material/table';

export type keyValueTableObject = {
  key: string;
  value: string | string[];
  display_name: string;
  link?: string;
}[];

@Component({
  selector: 'app-key-value-table',
  imports: [MatCell, MatColumnDef, MatHeaderCell, MatRow, MatTable, MatTableModule],
  templateUrl: './key-value-table.component.html',
})
export class KeyValueTableComponent implements OnChanges {
  @Input() rowsToDisplay?: keyValueTableObject;
  columnData: keyValueTableObject;
  displayedColumns: string[] = ['key', 'value'];

  ngOnChanges(): void {
    this.buildColumnData();
  }

  /** buildColumnData: Takes any list of objects, which have these at least these attributes:
   *                   key, value, display_name
   *                   And produces a key-value table, styled with material.
   *                   NOTE: Values should be immutable string(s). Format arrows/commas/etc in the parent component!
   * */
  buildColumnData() {
    if (!this.rowsToDisplay) return;
    // Remove all empty or falsy elements
    this.columnData = this.rowsToDisplay.filter(x =>
      Array.isArray(x.value)
        ? x.value.some(v => v !== '' && v !== null && v !== undefined)
        : x.value !== '' && x.value !== null && x.value !== undefined,
    );
  }

  protected readonly Array = Array;
}
